import React, { useState } from 'react';
import reportService from '../../services/reportService';
import { LoadingSpinner } from '../../components';
import moment from 'moment';
import NoData from '../../components/NoData';
import { MdOutlineArrowRightAlt } from 'react-icons/md';
import HeaderTitle from '../../components/HeaderTitle';
import { useWindowWidth } from '@react-hook/window-size';
import ByDateMobile from './mobile/ByDateMobile';
import SelectBox from '../../components/SelectBox';

const transactionFilters = [
  { name: 'All Transactions', value: 'all' },
  { name: 'Win', value: 'Win' },
  { name: 'Lose', value: 'Lose' },
  { name: 'Bet Out', value: 'Bet Out' },
  { name: 'Bet In', value: 'Bet In' },
  { name: 'Transfer In', value: 'Transfer In' },
  { name: 'Transfer Out', value: 'Transfer Out' },
  { name: 'Commission In', value: 'Commission In' },
  { name: 'Commission Out', value: 'Commission Out' },
  { name: 'Reject', value: 'Reject' }
];

const TransactionByDate = () => {
  const onlyWidth = useWindowWidth();
  const isCompactWidth = onlyWidth < 640;
  const isDesktop = onlyWidth > 768;
  const mobileFilterWrapper = isCompactWidth ? 'bg-customBackColor/95 backdrop-blur-md dark:bg-custom_dark_background/95' : '';
  const filterSpacingClass = isCompactWidth ? 'pt-2 pb-2' : 'mt-4';
  const filterCardPadding = isCompactWidth ? 'p-4' : 'p-6';
  const contentSpacingClass = isDesktop ? 'mt-4' : 'mt-2';
  const mobileContentSpacing = isCompactWidth ? 'mt-2' : 'mt-4';

  const [isLoading, setIsLoading] = useState(false);
  const [trasactionData, setTransactionData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [name, setName] = useState('');
  const [date, setDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [filter, setFilter] = useState(transactionFilters[0]);
  const [balance, setBalance] = useState({
    openingBalance: 0,
    closingBalance: 0
  });

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const payload = {
        name: name,
        selectedDate: date
      };
      const response = await reportService.getUserTransaction(payload);

      if (response.status === 200) {
        const payload = response.data.transactions;
        setTransactionData(payload);
        setShowData(payload);
        setBalance(value => ({
          ...value,
          openingBalance: payload[0].balance,
          closingBalance: payload[payload.length - 1].balance
        }));
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData();
  };

  const handleSelect = (v) => {
    setFilter(v);
    let value = v.value;

    const filteredData = value === 'all' ? trasactionData : trasactionData.filter(a => a.transactionType === value);
    setShowData(filteredData);
  };

  const renderTransactionPerson = (createdBy, transactionType, inward, outward, description) => {
    const obj = {};

    switch (transactionType) {
      case 'Bet Out':
        obj['from'] = createdBy;
        obj['to'] = 'admin';
        obj['balance'] = outward;
        break;
      case 'Transfer In':
        obj['from'] = description.split('-')[1];
        obj['to'] = name;
        obj['balance'] = inward;
        break;
      case 'Win':
        obj['from'] = 'admin';
        obj['to'] = createdBy;
        obj['balance'] = inward;
        break;
      case 'Reject':
        obj['from'] = createdBy;
        obj['to'] = 'admin';
        obj['balance'] = inward;
        break;
      case 'Commission In':
        obj['from'] = 'admin';
        obj['to'] = createdBy;
        obj['balance'] = inward;
        break;
      case 'Transfer Out':
        obj['from'] = name;
        obj['to'] = description.split('-')[1];
        obj['balance'] = outward;
        break;
      default:
        break;
    }

    return obj;
  };

  return (
    <div className="min-h-screen bg-customBackColor/60 pb-20 dark:bg-custom_dark_background">
      <div className="mx-auto w-full max-w-6xl px-3 sm:px-6">
        <div className="py-2">
          <HeaderTitle title={'Transaction History By UserID'} />
        </div>
      </div>

      <div className={`${mobileFilterWrapper} relative z-30`}>
        <div className={`mx-auto w-full max-w-6xl px-3 sm:px-6 ${filterSpacingClass}`}>
          <div className={`relative z-30 rounded-2xl border border-customAccent/25 bg-gradient-to-br from-customSlate/80 via-white to-customSky/70 ${filterCardPadding} shadow-xl shadow-customAccent/10 backdrop-blur-sm dark:border-customSurface dark:from-customSurface dark:via-customSurface dark:to-customSurfaceMuted`}>
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div>
                <h2 className="text-base font-semibold text-customInk dark:text-customHeading">
                  Transaction Overview
                </h2>
                <p className="mt-1 text-xs text-customSecondaryText dark:text-customMuted sm:text-sm">
                  Search by user and date to review balance changes across transaction types.
                </p>
              </div>
              <div className="grid w-full gap-3 sm:grid-cols-2 md:w-auto md:grid-cols-2 md:justify-end">
                <div className="flex flex-col gap-1 rounded-2xl bg-white/85 px-4 py-3 shadow-md shadow-customAccent/10 backdrop-blur dark:bg-customSurface sm:min-w-[200px]">
                  <span className="text-[10px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
                    Opening Balance
                  </span>
                  <span className="text-base font-bold text-customInk dark:text-customHeading sm:text-lg">
                    {typeof balance.openingBalance === 'number' ? balance.openingBalance.toLocaleString('en-US') : balance.openingBalance}
                  </span>
                </div>
                <div className="flex flex-col gap-1 rounded-2xl bg-white/85 px-4 py-3 shadow-md shadow-customAccent/10 backdrop-blur dark:bg-customSurface sm:min-w-[200px]">
                  <span className="text-[10px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
                    Closing Balance
                  </span>
                  <span className="text-base font-bold text-customAccentBlue dark:text-customHeading sm:text-lg">
                    {typeof balance.closingBalance === 'number' ? balance.closingBalance.toLocaleString('en-US') : balance.closingBalance}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
              <label className="flex flex-col gap-1 text-[11px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted sm:gap-2 sm:text-xs">
                <span>Transaction Date</span>
                <input
                  className="h-11 rounded-2xl border border-white/60 bg-white/95 px-3 text-sm font-medium text-customInk shadow-inner focus:border-customAccentBlue focus:outline-none focus:ring-2 focus:ring-customAccentBlue/30 dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customHeading"
                  type="date"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                />
              </label>
              <label className="relative z-40 flex flex-col gap-1 text-[11px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted sm:gap-2 sm:text-xs">
                <span>Transaction Type</span>
                <SelectBox
                  selected={filter}
                  setSelected={handleSelect}
                  options={transactionFilters}
                  isMobile={onlyWidth < 640}
                  placeholder="All transactions"
                />
              </label>
              <label className="flex flex-col gap-1 text-[11px] font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted sm:gap-2 sm:text-xs">
                <span>User ID</span>
                <input
                  className="h-11 rounded-2xl border border-white/60 bg-white/95 px-3 text-sm font-medium text-customInk shadow-inner focus:border-customAccentBlue focus:outline-none focus:ring-2 focus:ring-customAccentBlue/30 dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customHeading"
                  placeholder="Search by User ID"
                  onChange={e => setName(e.target.value)}
                />
              </label>
              <div className="flex items-end">
                <button
                  type="button"
                  onClick={handleSearch}
                  className="flex h-11 w-full items-center justify-center rounded-2xl bg-customAccentBlue text-sm font-semibold text-white shadow-lg shadow-customAccentBlue/30 transition hover:bg-customAccentBlue/80 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/50 dark:bg-customAccent dark:text-customHeading"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isDesktop ? (
        <div className={`relative z-10 mx-auto w-full max-w-6xl px-3 sm:px-6 ${contentSpacingClass}`}>
          <div className="overflow-hidden rounded-3xl border border-customAccent/20 bg-white/90 shadow-2xl shadow-customAccent/10 backdrop-blur dark:border-customSurface dark:bg-customSurface">
            <div className="flex flex-col gap-2 border-b border-customAccent/10 bg-gradient-to-r from-customSlate/70 to-customSky/60 px-5 py-4 dark:border-customSurfaceMuted dark:from-customSurface dark:to-customSurfaceMuted">
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <h3 className="text-base font-semibold text-customInk dark:text-customHeading">
                  Transactions
                </h3>
                <span className="text-xs font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
                  Showing {showData.length} record{showData.length === 1 ? '' : 's'}
                </span>
              </div>
              <p className="text-xs text-customSecondaryText dark:text-customMuted">
                Monitor the flow of funds with color-coded transaction states.
              </p>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[720px]">
                <thead className="text-xs uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
                  <tr className="h-14 bg-background text-left dark:bg-customSurfaceMuted/60">
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">Date / Time</th>
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">Transaction Type</th>
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">Descriptions</th>
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">
                      <div className="flex items-center gap-2">
                        From <MdOutlineArrowRightAlt className="text-lg" /> To
                      </div>
                    </th>
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">Balance</th>
                    <th className="px-4 text-xs font-semibold text-customLightMilkWhite dark:text-customHeading">After</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-customSlate/30 bg-white/70 text-sm font-medium text-customInk dark:divide-customSurfaceMuted dark:bg-transparent dark:text-customHeading">
                  {isLoading ? (
                    <tr>
                      <td colSpan={6} className="py-10">
                        <div className="flex justify-center">
                          <LoadingSpinner />
                        </div>
                      </td>
                    </tr>
                  ) : showData.length > 0 ? (
                    showData.map(el => {
                      const persona = renderTransactionPerson(el.createdBy, el.transactionType, el.inward, el.outward, el.description);
                      const highlightColor = transactionColor[el.transactionType];
                      const highlightStyle = highlightColor ? { color: highlightColor } : undefined;
                      const rowKey = el.transactionId || el.id || `${el.createdDate}-${el.balance}`;
                      return (
                        <tr
                          key={rowKey}
                          className="h-16 transition hover:bg-customSlate/20 dark:hover:bg-customSurfaceMuted/60"
                        >
                          <td className="px-4 text-sm text-customSecondaryText dark:text-customHeading">
                            {moment(el.createdDate).format('DD-MM-YYYY hh:mm A')}
                          </td>
                          <td className="px-4 text-sm" style={highlightStyle}>
                            {el.transactionType}
                          </td>
                          <td className="px-4 text-sm">
                            {el?.description ? el.description : ''}
                          </td>
                          <td className="px-4">
                            <div className="flex items-center gap-3 text-sm">
                              {persona.from}
                              <MdOutlineArrowRightAlt />
                              {persona.to}
                            </div>
                          </td>
                          <td className="px-4 text-sm text-customInk dark:text-customHeading">
                            <div className='flex gap-1'>
                              <span>{persona.balance.toLocaleString('en-US')}</span>
                              <span className='text-[10px] text-customSecondaryText'>MMK</span>
                            </div>     
                          </td>
                          <td className="px-4 text-sm text-customInk dark:text-customHeading">                           
                            <div className='flex gap-1'>
                              <span>{el.balance.toLocaleString('en-US')}</span>
                              <span className='text-[10px] text-customSecondaryText'>MMK</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} className="py-16">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className={`mx-auto w-full max-w-6xl px-3 sm:px-6 overflow-hidden h-full ${mobileContentSpacing}`}>
          <ByDateMobile isLoading={isLoading} showData={showData} renderTransactionPerson={renderTransactionPerson} />
        </div>
      )}
    </div>
  );
};

export default TransactionByDate;

const transactionColor = {
  'Bet Out': '#8A42B8',
  'Bet In': '#8A42B8',
  'Win': '#008000',
  'Reject': '#B41D4B',
  'Transfer Out': '#0E93A9',
  'Transfer In': '#0E93A9',
  'Commission Out': '#BA8E23',
  'Commission In': '#BA8E23'
};
